import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import PrivateRoute from '../../../hocs/PrivateRoute'
import FollowUpsPage from './Page'

// Routes for the follow-up messages (spec: duty-follow-up-messages).
const FollowUpsRoutes = props => (
  <RouterSwitch>
    <PrivateRoute exact path={props.match.path} component={FollowUpsPage} />
  </RouterSwitch>
)

FollowUpsRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(FollowUpsRoutes)
